import {Accordion, Card} from "react-bootstrap"
import AboutTheCompanyTemplate from "./Templates/AboutTheCompanyTemplate";

const SebiOS = () => {

    const Heading = () => <h4 className={'fst-italic'}>SEB - iOS</h4>

    const AboutTheCompany = () =>
        <AboutTheCompanyTemplate>
            Transitioned from QA role to
            iOS development to experience software development from the other side 🤞.
            SEB mobile apps team is one of the forward most innovative teams at SEB where were we design and innovate with
            the latest technologies and bringing in the best banking experience to our customers.
        </AboutTheCompanyTemplate>

    const Role = () =>
        <div>
            <h5>Role</h5>
            <p>iOS Engineer</p>
        </div>

    const Duration = () =>
        <div>
            <h5>Duration</h5>
            <p>2026 to current</p>
        </div>

    const ContributionHeading = () => <h5>Key responsibilities</h5>
    const ContributionDescription = () =>
        <ul>
            <li>
                Maintain and add new features in the SEB mobile apps.
            </li>
            <li>
               Bring in QA expertise to enhance quality of the app and speed up the delivery
               process.
            </li>
            <li>
                Enhance usability based on different segments of customers and different personas.
            </li>
        </ul>

    const Contribution = () =>
        <div>
            <ContributionHeading/>
            <ContributionDescription/>
        </div>

    const uniqueKey = "8"

    return (
        <Card className={'border-top border-left border-right border-primary-subtle'}>
            <Accordion.Item eventKey={uniqueKey}>
                <Accordion.Header as={Card.Header} eventKey={uniqueKey}>
                    <Heading/>
                </Accordion.Header>
                <Accordion.Collapse eventKey={uniqueKey}>
                    <Card.Body>
                        <AboutTheCompany/>
                        <Role/>
                        <Duration/>
                        <Contribution/>
                    </Card.Body>
                </Accordion.Collapse>
            </Accordion.Item>
        </Card>
    )
}

export default SebiOS
